import { Component, OnInit } from '@angular/core';
import { DECIMALS } from '@app/core/constants/decimals';
import { CellRenderer } from '@shared/interfaces/table/cell-renderer';

@Component({
  selector: 'app-append-decimals-cell',
  imports: [],
  templateUrl: './append-decimals-cell.component.html',
  styleUrl: './append-decimals-cell.component.css'
})
export class AppendDecimalsCellComponent extends CellRenderer implements OnInit {
  public valueToShow!: string;

  protected DIGITS = DECIMALS;

  public ngOnInit(): void {
    if (this.params?.cellRendererParams?.digits) {
      this.DIGITS = this.params.cellRendererParams.digits;
    }

    this.valueToShow = `${this.value},${'0'.repeat(this.DIGITS)}`

  }
}
